import { Component, Input } from '@angular/core';
import { ContentPath } from '../../../../models/search-results';

@Component({
    selector: 'app-path-result',
    templateUrl: './path-result.component.html',
    styleUrls: ['./path-result.component.scss'],
    standalone: false
})
export class PathResultComponent {
    @Input() path: ContentPath;
}
